import { types } from 'mobx-state-tree';
import { UsersStore } from './UsersStore';
import { CompanyStore } from './CompanyStore';
import { AssessmentsStore } from './AssessmentsStore';
import { AdminStore } from './AdminStore';
import { ModulesStore } from './Modules';
import { VideoPresentationStore } from './VideoPresentationStore';
import { MeetingStore } from './MeetingStore';
import { MeetingsStore } from './MeetingsStore';
import LiveMeetingsStore from './LiveMeetingsStore';
import { MyMeetingsStore } from './MyMeetingsStore';
import { BotInspectorStore } from './BotInspectorStore';

export const RootStore = types.model({
    usersStore: types.optional(UsersStore, {}),
    companyStore: types.optional(CompanyStore, {}),
    assessmentsStore: types.optional(AssessmentsStore, {}),
    adminStore: types.optional(AdminStore, {}),
    modulesStore: types.optional(ModulesStore, {}),
    videoPresentationStore: types.optional(VideoPresentationStore, {}),
    meetingStore: types.optional(MeetingStore, {}),
    meetingsStore: types.optional(MeetingsStore, {}),
    liveStore: types.optional(LiveMeetingsStore, {}),
    myMeetingsStore: types.optional(MyMeetingsStore, {}),
    botInspectorStore: types.optional(BotInspectorStore, {}),
});

export const CreateRootStore = () => {
    try {
        return RootStore.create(
            {
                usersStore: UsersStore.create(),
                companyStore: CompanyStore.create(),
                assessmentsStore: AssessmentsStore.create(),
                adminStore: AdminStore.create(),
                modulesStore: ModulesStore.create(),
                videoPresentationStore: VideoPresentationStore.create(),
                meetingStore: MeetingStore.create(),
                meetingsStore: MeetingsStore.create(),
                liveStore: LiveMeetingsStore.create(),
                myMeetingsStore: MyMeetingsStore.create(),
                botInspectorStore: BotInspectorStore.create(),
            }
        );
    }
    catch (error) {
        console.log(error);
    }
};